import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AuthLockScreen from "../pages/Authentication/AuthLockScreen";
import Dashboard from "../pages/Dashboard";
import Order from "../pages/Order";
import CreateFiller from "../pages/Fillers/Create";
import CreateOrder from "../pages/Order/Create";
import Calendar from "../pages/Calendar";
import Transaction from "pages/Transaction";
import AddTransaction from "pages/Transaction/Create";
import Maintenance from "pages/Common/Maintenance";
import Fillers from "../pages/Fillers";
import Customers from "../pages/Customers";
import CreateCustomer from "../pages/Customers/Create";
import Nozzles from "../pages/Nozzles";
import CreateNozzle from "pages/Nozzles/Create";
import Prices from "pages/Price";
import Report from "pages/Report";
import DailyReport from "pages/Report/DailyReport";
import LedgerReport from "pages/Report/LedgerReport";
import FullReport from "pages/Report/FullReport";
import ProfitReport from "pages/Report/ProfitReport";
import Users from "pages/Users";
import CreateUser from "pages/Users/Create";
import ProfilePage from "pages/Authentication/Profile";
import AccountantHistory from "pages/Transaction/AccountantHistory";
import TransactionReport from "pages/Report/TransactionReport";
import StockHistory from "pages/Transaction/StockHistory";
import CreateBilling from "pages/Report/CreateBilling";
import BillingHistory from "pages/Report/BillingHistory";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/calendar", component: <Calendar /> },

  //Teachers Toutes
  { path: "/fillers", component: <Fillers /> },
  { path: "/add-filler", component: <CreateFiller /> },

  //Students Routes
  { path: "/customers", component: <Customers /> },
  { path: "/add-customer", component: <CreateCustomer /> },

  //Order Routes
  { path: "/orders", component: <Order /> },
  { path: "/add-order", component: <CreateOrder /> },

  //Students Routes
  { path: "/transactions", component: <Transaction />, role: 1 },
  { path: "/add-transaction", component: <AddTransaction />, role: 1 },

  //Students Routes
  { path: "/nozzles", component: <Nozzles />, role: 1 },
  { path: "/prices", component: <Prices />, role: 1 },
  { path: "/reports", component: <Report />, role: 1 },
  { path: "/daily-report", component: <DailyReport />, role: 1 },
  { path: "/ledger-report", component: <LedgerReport />, role: 1 },
  { path: "/full-report", component: <FullReport />, role: 1 },
  { path: "/profit-report", component: <ProfitReport />, role: 1 }, 
  { path: "/create-billing", component: <CreateBilling />, role: 1 },
  { path: "/billing-history", component: <BillingHistory />, role: 1 },
  { path: "/add-nozzle", component: <CreateNozzle /> },
  { path: "/transaction-report", component: <TransactionReport />, role: 1 },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },

  { path: "/users", component: <Users />, role: 1 },
  { path: "/add-user", component: <CreateUser />, role: 1 },
  { path: "/accountant-history", component: <AccountantHistory />, role: 1 },
  { path: "/stock-history", component: <StockHistory />,  },
  { path: "/profile", component: <ProfilePage /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/lock-screen", component: <AuthLockScreen /> },

  { path: "/maintenance", component: <Maintenance /> },
];

export { authProtectedRoutes, publicRoutes };
